module.exports = __webpack_public_path__ + "img/envelope_closed.b49929be.svg";